<template>
  <ion-list v-if="resources.data.length > 0">
    <ion-item
      v-for="item in resources.data"
      :key="item.id"
      :ref="`items-${item.id}`"
      class="hydrated link"
    >
      <ion-label @click="openPopover(item, $event)">
        <h2 :class="{ disabledItem: item.roles[0].name !== 'student' }">
          {{ item.user_detail.name }}
        </h2>
        <p v-if="item.student_trashed">
          {{ item.student_trashed.section_standard.standard.name }} -
          {{ item.student_trashed.section_standard.section.name }} [Roll:
          {{ item.student_trashed.roll_no }}]
        </p>
        <p v-else>No class assigned.</p>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No de-listed students</p>
    </ion-list-header>
  </ion-list>
  <ion-modal
    :is-open="updateModalState"
    @didDismiss="setUpdateModalState(false)"
  >
    <base-modal
      title="Re-enlist student"
      @closeModal="setUpdateModalState(false)"
    >
      <update-delist-student
        @closeModal="setUpdateModalState(false)"
        :resource="resourceToUpdate"
      ></update-delist-student>
    </base-modal>
  </ion-modal>

  <ion-popover
    :is-open="popoverState"
    :event="popoverEvent"
    @didDismiss="setPopoverState(false)"
  >
    <base-popover
      @closePopover="setPopoverState(false)"
      :title="selectedResource.user_detail.name"
    >
      <ion-item button @click="setResourceToUpdate(selectedResource.id)"
        >Edit</ion-item
      >
    </base-popover>
  </ion-popover>
</template>
<script>
import BaseModal from "../../../Base/BaseModal";
import UpdateDelistStudent from "../Student/UpdateDelistedStudent.vue";
import BasePopover from "../../../Base/BasePopover.vue";
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonPopover,
  IonModal,
} from "@ionic/vue";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonModal,
    BaseModal,
    IonPopover,
    BasePopover,
    UpdateDelistStudent,
  },
  data() {
    return {
      updateModalState: false,

      popoverState: false,
      popoverEvent: null,
      selectedResource: null,

      resourceToUpdate: {
        id: null,
        name: null,
      },
    };
  },
  methods: {
    setUpdateModalState(state) {
      this.updateModalState = state;
      if (state == false) {
        this.setPopoverState(false);
      }
    },

    setResourceToUpdate(id) {
      const resource = this.resources.data.find(
        (resource) => resource.id === id
      );
      this.resourceToUpdate = resource;
      this.setUpdateModalState(true);
    },

    openPopover(resource, ev) {
      this.popoverEvent = ev;
      this.setSelectedResource(resource);
      this.setPopoverState(true);
    },

    setPopoverState(state) {
      this.popoverState = state;
    },

    setSelectedResource(resource) {
      this.selectedResource = resource;
    },
  },
};
</script>
